import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { delay, reduce } from 'lodash';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import { Modal, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
// Import Actions
import { fetchDomainAuthorizations } from '../../modules/Admin/AdminActions';
import { getTVDomains } from '../../modules/Admin/AdminReducer';
// Import Selectors
import { getUserCurrentOrganization } from '../../modules/Auth/AuthReducer';

class TruVoiceDomainAuthorization extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }

  componentDidMount() {
    delay(() => {
      this.load();
    }, 500);
  }


  load() {
    if (this.props.loading || this.props.hasErrors || this.props.loaded) {
      return;
    }
    const organization = this.getOrganization();
    this.props.dispatch(fetchDomainAuthorizations(organization?._id))
      .then(
        () => {
        },
        () => {
        },
      );
  }

  close() {
    this.setState({ show: false });
  }
  
  open() {
    this.setState({ show: true });
  }

  getOrganization() {
    const { userOrganization, organization } = this.props;
    return organization || userOrganization;
  }

  renderErrors() {
    return null; // do nothing for now
  }

  renderClientDomain(client, domain) {
    const id = `${client.id}|${domain.domain}`;
    const isAuthorized = domain.authorized === true;

    const tip = (
      <Tooltip id={id}>
        <div>{isAuthorized ? 'Authorized' : 'Not Authorized'}</div>
      </Tooltip>
    );


    return (
      <OverlayTrigger key={id} trigger={['hover', 'focus']} placement="top" overlay={tip}>
        <span className={isAuthorized ? 'text-success' : 'text-danger'}>
          {domain.domain} <Fa name={isAuthorized ? 'check-circle' : 'exclamation-triangle'} />
        </span>
      </OverlayTrigger>
    );
  }

  renderClient(client, renderName = false) {
    const isList = this.props.isModal;
    const name = (<span key={`client-name-${client.id}`}><strong>{client.name}: </strong></span>);
    const total = client.domains?.length;

    const domainLists = reduce(client.domains, (items, domain, idx) => {
      const item = this.renderClientDomain(client, domain);
      if (isList) {
        items.push((<li key={`${client.id}|${domain.domain}}`}>{item}</li>));
      } else {
        items.push(item);
        if (idx < total - 1) {
          items.push((<small key={`${client.id}|${domain.domain}}-comma`} className="text-muted"> | </small>));
        }
      }
      return items;
    }, []);

    return [
      ...(renderName ? [name] : []),
      ...(isList ? [<ul key={`${client.id}-list`}>{domainLists}</ul>] : domainLists),
    ];
  }


  renderBody() {
    const { clients, hasSetup } = this.props;
    const isList = this.props.isModal;
    const total = clients.length;
    const header = (<strong>Domain Authorization Status: </strong>);

    if (!hasSetup) {
      if (isList) {
        return (
          <div className="alert alert-warning">
            No domains found.
          </div>
        );
      }
      return null;    
    }
    const clientLists = reduce(clients, (items, client, idx) => {
      const item = this.renderClient(client, total > 1);
      if (isList) {
        if (total > 1) {
          items.push((<li key={`${client.id}-item`}>{item}</li>));
        } else {
          items.push((item));
        }
      } else {
        items.push(item);
        if (idx < total - 1) {
          items.push((<span key={`${client.id}-comma`} className="text-muted"> | </span>));
        }
      }
      return items;
    }, []);


    if (isList) {
      if (total > 1) {
        return (
          <ul key="list">{clientLists}</ul>
        );
      }
      return clientLists;
    }
    
    
    return (
      <div>
        {header} {clientLists}
      </div>
    );
  }

  renderModalErrors() {
    const { bsSize, errors } = this.props;
    const { show } = this.state;
    return [
      (
        <Button key="button" onClick={this.open} bsStyle="link" bsSize={bsSize}><span className="text-danger"><Fa name="exclamation-triangle" /> Errors</span></Button>
      ),
      (
        <Modal key="modal" show={show} onHide={this.close}>
          <Modal.Header closeButton>
            <h4>Domain Authorization Status</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="alert alert-danger">{JSON.stringify(errors, null, 2)}</div>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="default" onClick={this.close}>Done</Button>
          </Modal.Footer>
        </Modal>
      ),
    ];
  }

  render() {
    const { isModal, bsSize } = this.props;
    const { show } = this.state;
    const { loading, loaded, hasDomainAuthorized } = this.props;
    if (loading) {
      return (<span className="text-muted" ><Fa name="spinner" spin /></span>);
    }
    if (!loaded) {
      if (isModal) {
        return this.renderModalErrors();  
      }
      return this.renderErrors();
    }

    if (isModal) {
      return [
        (
          <Button key="button" onClick={this.open} bsStyle="link" bsSize={bsSize}>
            <span className={hasDomainAuthorized ? 'text-success' : 'text-warning'}>
              <Fa name={hasDomainAuthorized ? 'check-circle' : 'exclamation-triangle'} /> {hasDomainAuthorized ? 'Yes' : 'No'}
            </span>
          </Button>
        ),
        (
          <Modal key="modal" show={show} onHide={this.close}>
            <Modal.Header closeButton>
              <h4>Domain Authorization Status</h4>
            </Modal.Header>
            <Modal.Body>
              {this.renderBody()}
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="default" onClick={this.close}>Done</Button>
            </Modal.Footer>
          </Modal>
        ),
      ];
    }
    return this.renderBody();
  }
}

TruVoiceDomainAuthorization.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isModal: PropTypes.bool,
  organization: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }),
  userOrganization: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
  bsSize: PropTypes.string,
  bsStyle: PropTypes.string,
  clients: PropTypes.arrayOf(PropTypes.shape({
  })).isRequired,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  hasErrors: PropTypes.bool,
  hasDomainAuthorized: PropTypes.bool,
  hasSetup: PropTypes.bool,
  errors: PropTypes.string,
};
TruVoiceDomainAuthorization.defaultProps = {
  isModal: false,
  organization: null,
  bsSize: 'sm',
  bsStyle: 'default',
  loading: false,
  loaded: false,
  hasErrors: false,
  hasSetup: false,
  errors: null,  
};

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const userOrganization = getUserCurrentOrganization(state);
  const organization = ownProps.organization || userOrganization;

  const tvDomain = getTVDomains(state, organization._id);
  return {
    userOrganization,
    clients: tvDomain?.clients || [],
    loading: tvDomain?.status === 'loading',
    loaded: tvDomain?.status === 'loaded',
    hasErrors: tvDomain?.status === 'error',
    hasDomainAuthorized: tvDomain.hasDomainAuthorized === true,
    hasSetup: tvDomain.hasSetup === true,
    errors: tvDomain?.errors,
  };
}
export default connect(mapStateToProps)(TruVoiceDomainAuthorization);
